<template>
  <div class="gmfinfo no-scroll-track">
    <!-- :class="{ gmfinfo_gmf_name_selected: idx === 0 }" -->

    <div
      class="weight_600 gmfinfo_html-title"
      v-html="gmfHtml"
    ></div>
    <div
      v-if="gameformat.maintenance"
      class="gmfinfo_item gmfinfo_item_note uppercase text-spacing_05 d-flex clr-yellow"
    >
      <div class="d-flex f-align-center weight_700">
        <i class="mdi mr-2 mdi-progress-wrench text-large clr-yellow"></i>
        {{ $t('messages.solution_maintenance') }}
      </div>
    </div>

    <div
      v-if="info.note"
      class="gmfinfo_item gmfinfo_item_note"
    >
      {{ $t(`gametypes.notes.${info.note}`) }}
    </div>
    <div
      class="d-flex"
      style="gap: 0.5em"
    >
      <table class="gmfinfo_items">
        <tr class="gmfinfo_item">
          <td class="gmfinfo_item_title">{{ $t('gameformat.spots') }}:</td>
          <td
            class="gmfinfo_item_box gmfinfo_item_box_bordered"
            :style="`--tag-clr:${
              gameformat.preflop_only ? 'var(--clr-yellow)' : 'var(--clr-primary)'
            }`"
          >
            {{ $t(`gameformat.${gameformat.preflop_only ? 'preflop_only' : 'all_spots'}`) }}
          </td>
        </tr>

        <tr
          v-if="info.flop_reports || info.turn_reports"
          class="gmfinfo_item gtt_rake"
        >
          <td class="gmfinfo_item_title">{{ $t('gameformat.reports') }}:</td>
          <td>
            <div class="gmfinfo_item_tags">
              <div
                v-if="info.flop_reports"
                class="gmfinfo_item_box gmfinfo_item_box_bordered"
                style="--tag-clr: var(--clr-primary)"
              >
                {{ $t(`common.flop`) }}
              </div>
              <div
                v-if="info.turn_reports"
                class="gmfinfo_item_box gmfinfo_item_box_bordered"
                style="--tag-clr: var(--clr-primary)"
              >
                {{ $t(`common.turn`) }}
              </div>
            </div>
          </td>
        </tr>

        <tr
          v-if="info.rake_text"
          class="gmfinfo_item gtt_rake"
        >
          <td class="gmfinfo_item_title">{{ $t('gameformat.rake') }}:</td>
          <td class="gmfinfo_item_box">
            {{
              $te(`gametypes.${info.rake_text}`)
                ? $t(`gametypes.${info.rake_text}`)
                : info.rake_text
            }}
          </td>
        </tr>

        <tr
          v-if="info.sizings"
          class="gmfinfo_item gtt_sizing"
        >
          <td class="gmfinfo_item_title">{{ $t('gameformat.sizing') }}:</td>
          <td class="gmfinfo_item_box">
            {{ info.sizings }}
          </td>
        </tr>

        <tr
          v-if="info.ante"
          class="gmfinfo_item gtt_ante"
        >
          <td class="gmfinfo_item_title">{{ $t('gameformat.ante') }}:</td>
          <td class="gmfinfo_item_box">{{ info.ante }} BB</td>
        </tr>

        <tr
          v-if="info.accuracy"
          class="gmfinfo_item gtt_ante"
        >
          <td class="gmfinfo_item_title">{{ $t('gameformat.accuracy') }}:</td>
          <td class="gmfinfo_item_box">
            {{ info.accuracy }}
          </td>
        </tr>
      </table>
    </div>

    <router-link
      v-if="!gameformat.subscription_tier || gameformat.subscription_tier == 'FREE'"
      :to="{
        name: 'SubscriptionOverview',
        query: { gm_type: gameformat.gm_type },
      }"
      target="_blank"
      class="gmfinfo_item gtt_note weight_500"
    >
      <div
        class="uppercase text-wrap gw_btn gw_btn_primary text-medium"
        style="height: unset; --padding: 0.25em 0.75em"
      >
        <i class="mdi mdi-crown text-semi-large mr-2"></i>
        {{ $t(`messages.upgrade_to_unlock`) }}
      </div>
    </router-link>
  </div>
</template>

<script>
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'

export default {
  name: 'GmfInfo',
  props: {
    // gameformat: Object,
    gameformat: {
      default: () => ({
        // is_subscribed: true,
        // preflop_only: true,
        maintenance: true,
        info: {
          note: 'note_cash_general',
          flop_reports: true,
          turn_reports: true,
          rake_text: 'no_rake',
          sizings: '0-999bb',
          ante: 1,
          accuracy: '0.3%',
        },
      }),
    },
  },
  data() {
    return {}
  },
  computed: {
    gmfHtml() {
      return getGameformatOptionHtml({
        gameformat: this.gameformat,
      })
    },
    info() {
      return this.gameformat?.info || null
    },
  },
}
</script>

<style lang="scss" scoped>
.gmfinfo {
  display: flex;
  flex-direction: column;
  grid-gap: 0.75em;
  position: relative;
  background: var(--clr-black-2);
  padding: 0.75em;
  border-radius: 4px;
  td {
    &:nth-child(2) {
      width: 100%;
    }
  }
  &_name {
    font-weight: 500;
    margin-right: auto;
    padding: 0 0 0.25em;
    border-bottom: solid 2px var(--clr-primary);
  }
  &_items {
    margin-right: auto;
    width: 100%;
    grid-gap: 0.5em;
    // border-spacing: 0.25em;
  }
  &_html-title {
    font-size: 1em;
  }
  &_item {
    grid-gap: 0.25em;
    vertical-align: baseline;
    &_title {
      white-space: nowrap;
      font-size: 0.875em;
      text-transform: uppercase;
      padding-right: 0.75em;
    }
    &_tags {
      display: flex;
      flex-direction: column;
      width: 100%;
      grid-gap: 0.125em;
    }
    &_box {
      font-size: 0.875em;
      font-weight: 500;
      text-transform: uppercase;
      padding: 0.125em 1em;
      border-radius: 4px;
      background: var(--clr-black-3);
      position: relative;
      overflow: hidden;
      --tag-clr: var(--clr-grey-2);
      &:before {
        content: '';
        height: 100%;
        width: 6px;
        position: absolute;
        left: 0;
        top: 0;
        background: var(--tag-clr);
      }
    }
    &_note {
      font-size: 0.875em;
      margin: 0 1em 0 0;
    }
    &_info {
      position: absolute;
      right: 1.25em;
      bottom: 1.25em;
    }
  }
}
</style>
